import React,{useEffect,useState} from 'react'
import { AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";

import  AppWrap from "../../wrapper/AppWrap"
import MotionWrap from '../../wrapper/MotionWrap';
import "./work.scss";
import Html from '../../assets/html.png'
import Book from '../../assets/book.png'
import Savoury from '../../assets/savaoury.png'
import Code from '../../assets/codehelp.png'
import Mall from '../../assets/mall.png'
import Social from '../../assets/social.jpg'
import Port from '../../assets/port.png'
import Keep from '../../assets/keep.png'
import Cart from '../../assets/cart.jpg'
import Stall from '../../assets/stall.jpg'
import Ecom from '../../assets/ecom.jpg'

// img name description tags[]
const experience=[
    // mern
    {img:Savoury,name:"Foodie Finds",description:"A Web-App Solution for Food Enthusiasts and Explorers 🍔🌮🍟",tags:["MERN","All"],codeLink:"https://github.com/RAHUL14KUMAR/savouryServerless"},
    {img:Code,name:"Code Help",description:"CodeHelp is a 1-to-1 tutoring platform, where you can just upload your doubt and you get assisted by a technical expert of that particular tech you are learning or you have doubt in.",tags:["MERN","All"],codeLink:"https://github.com/rohitranjan-2702/CodeHelp_Final"},
    {img:Mall,name:"Mall Management",description:"It is mixture of 2 website like Amazon/Flipart and Khatabook.",tags:["MERN","All"],codeLink:"https://github.com/RAHUL14KUMAR/mallMangement"},
    {img:Social,name:"Social Platform",description:"It is a social media application having similar implementaion like facebook",tags:["MERN","All"],codeLink:"https://github.com/RAHUL14KUMAR/socialMedia"},

    // react
    {img:Port,name:"Portfolio",description:"my first Portfolio",tags:["React JS","All"],codeLink:"https://github.com/RAHUL14KUMAR/portfolio"},
    {img:Keep,name:"Google Keep",description:"Google keep clone similar to TODO task",tags:["React JS","All"],codeLink:"https://github.com/RAHUL14KUMAR/google_keep"},
    {img:Cart,name:"React Cart",description:"It is a react component which follow all the function that user does while shoping in Amazon/Flipkart",tags:["React JS","All"],codeLink:"https://github.com/RAHUL14KUMAR/reactCart"},  

    // next js
    {img:Ecom,name:"Ecommerce",description:"It is a Ecommerce website where user can buy the products and it cover allmost all function that Amazon have",tags:["Next JS","All"],codeLink:"https://github.com/RAHUL14KUMAR/NEXTJS-TYPESCRIPT-PORTFOLIO"},
    {img:Stall,name:"Foodie Finds",description:"A Web-App Solution for Food Enthusiasts and Explorers 🍔🌮🍟",tags:["Next JS","All"],codeLink:"https://github.com/RAHUL14KUMAR/nextjs-setup"},

    // Html
    {img:Html,name:"PostPe",description:"make a clone of Postpe using CSS",tags:["HTML CSS","All"],codeLink:"https://github.com/RAHUL14KUMAR/postpe-clone"},
    {img:Book,name:"Book",description:"make a book site where user can see new book in the store",tags:["HTML CSS","All"],codeLink:"https://github.com/RAHUL14KUMAR/bookssite"}
]

function Work() {
  const [works, setWorks] = useState(experience);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(()=>{
    setFilterWork(works)
  },[])
  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  return (
    <>
      <h2 className="head-text">
        My Demo Projects <span>Code</span> And Description
      </h2>

      <div className="app__work-filter">
        {["MERN", "React JS", "Next JS", "HTML CSS", "All"].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex p-text ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={work.img} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-hover app__flex"
              >
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  )
}

export default AppWrap(
    MotionWrap(Work, "app__works"),
    "work",
    "app__primarybg"
  );
